import React from 'react';
import { usesTableMap } from '../../utils/roomMode.ts';

type FloorStats = {
  total: number;
  occupied: number;
  available: number;
};

type RoomFloorTabsProps = {
  floors: any[];
  currentFloor: string | number | null | undefined;
  setCurrentFloor: (floorId: string | number) => void;
  floorStats: Map<string, FloorStats>;
  usarMapaMesas: boolean;
};

const RoomFloorTabs: React.FC<RoomFloorTabsProps> = ({
  floors,
  currentFloor,
  setCurrentFloor,
  floorStats,
  usarMapaMesas: legacyMapDefault,
}) => {
  if (floors.length === 0) {
    return null;
  }

  return (
    <div className="room-tabs">
      {floors.map((floor) => {
        const usarMapaMesas = usesTableMap(floor, legacyMapDefault);
        const stats = floorStats.get(String(floor.id)) || {
          total: usarMapaMesas ? (floor.tables?.length || 0) : (Number(floor.capacidade_maxima) || 0),
          occupied: 0,
          available: 0,
        };
        const isActive = String(currentFloor) === String(floor.id);
        return (
          <button
            key={floor.id}
            type="button"
            className={`room-tab ${isActive ? 'active' : ''}`}
            onClick={() => setCurrentFloor(floor.id)}
          >
            <span className="room-tab-title">{floor.name}</span>
            <span className="room-tab-meta">
              {stats.occupied}/{stats.total} {usarMapaMesas ? 'ocupadas' : 'cadeiras ocupadas'}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default RoomFloorTabs;
